import React from "react";

const About = () => {
  return (
    <div className="w-full md:h-screen bg-[#0B0F1F] text-gray-300">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full scale-95">
        <div>
          <div className="max-w-6xl mx-auto h-48">
            <h1
              name="about"
              className="text-5xl md:text-8xl font-bold py-20 text-center md:text-left text-[#cf6c2f]"
            >
              About Me...
            </h1>
          </div>
          <p className="text-2xl md:text-3xl text-[#8892b0]"># What I do?</p>
        </div>
        <p
          className="leading-loose text-1xl md:text-2xl font-semibold text-gray-300"
          style={{ lineHeight: "3rem" }}
        >
          I'm a developer, enjoys creating digital products and apps
          that have societal impact...{" "}
          <p>
            Currently working on{" "}
            <a
              className="bg-[#CF6C2F] rounded-md px-2 pb-1 md:text-3xl space-y-2 text-white"
              href="/"
            >
              {"Zero Knowledge Proof based Cryptocurrency Wallet"}
            </a>
          </p>
        </p>
        <div className="pt-12 grid grid-cols-1 md:grid-cols-3 max-w-6xl mx-auto gap-y-10 gap-x-20">
          <div className="inline-flex flex-col">
            <h2 className="text-xl font-semibold text-gray-200 text-justify">
              Job Opportunities
            </h2>
            <p className="text-lg mt-4 text-gray-300">
              If you see me as a good fit, check my{" "}
              <a
                href="./Yathin-Prakash-Kethepalli__CV.pdf"
                target="__blank"
                rel="noreferrer"
                className="border-b-2 border-[#CF6C2F] font-bold text-[#CF6C2F] hover:bg-[#CF6C2F] rounded-lg px-2 hover:text-gray-200"
              >
                Curriculum Vitae
              </a>{" "}
              and I'd love to work for you.
            </p>
          </div>
          {/* Text area */}
          <div className="col-span-1 md:col-span-2">
            <p className="text-xl mb-4 text-gray-300 text-justify">
              An inquisitive person, with good analytical & programming skills,
              interested in learning & building solutions around problems and
              latent needs using technological and interdisciplinary skills. In
              order to become a leader in the field of study, I want to hasten
              my learning. I want to develop the abilities required to deal with
              the world's resource shortage. I'm looking forward to
              strengthening my talents and gaining knowledge through
              research-based learning.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
